import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { catchError, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { clearMsalAccounts } from 'src/app/modules/auth/utils/msal-cache.util';

export const unauthorizedHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  const router = inject(Router);
  // Injected here (not AuthService) to avoid a circular DI: AuthService's
  // constructor fires an HTTP request that runs through this interceptor.
  const msalService = inject(MsalService);

  const isJwtApi = (url?: string | null) => {
    return !!url && url.startsWith(environment.apiUrl);
  };

  if (router.url.startsWith('/auth/login')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((res: HttpErrorResponse) => {
      if (res.status === 401) {
        // TODO: Refactor when we remove JWT auth and change to MSAL for .NET API
        const targetUrl = res?.url || req.url;
        if (isJwtApi(targetUrl)) {
          localStorage.removeItem(authLocalStorageToken);
          // Drop the MSAL session in lockstep with the JWT so the login page
          // can't silently re-auth against a now-stale account — it forces a
          // clean interactive sign-in instead.
          clearMsalAccounts(msalService.instance);
          router.navigate(['/auth/login'], {
            queryParams: {},
          });
          return of(null);
        }
      }

      return throwError(() => res);
    })
  );
};
